var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M6 15.167c0 .916.75 1.666 1.667 1.666H8.5c.917 0 1.667-.75 1.667-1.666 0-.917-.75-1.667-1.667-1.667.917 0 1.667-.75 1.667-1.667 0-.916-.75-1.666-1.667-1.666h-.833c-.917 0-1.667.75-1.667 1.666"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M19.333 3.5h-17.5A.833.833 0 0 0 1 4.333v15c0 .46.373.834.833.834h17.5c.46 0 .834-.373.834-.834v-15a.833.833 0 0 0-.834-.833M1 7.667h19.167M16.834 1v4.167M4.334 1v4.167"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M14.333 16.833v-6.666l-1.667 1.666"
})));
export default SvgCalendar;